module.exports = __webpack_public_path__ + "static/media/H48104-guides.7c785dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handleAlphas/H48104-guides.png
// module id = 122
// module chunks = 0